import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Link } from 'react-router'

import createImageUrl from '../../shared/createImageUrl'
import getPath from '../../../shared/utils/getPath'

const trim = (str, len) => {
  if (str.length <= len) {
    return str
  }
  //trim the string to the maximum length
  const trimmed = str.substr(0, len)

  //re-trim if we are in the middle of a word
  return `${trimmed.substr(0, Math.min(trimmed.length, trimmed.lastIndexOf(' ')))}...`
}

@observer
export default
class ItemPreviewItem
  extends Component {

  static propTypes = {
    item: PropTypes.object.isRequired,
    size: PropTypes.number.isRequired
  };

  render() {
    const { item, size } = this.props

    if (!item.imageUrl) {
      return null
    }

    const url = createImageUrl({ url: item.imageUrl }, size)

    const summary = trim(item.description, 300)

    return (
      <div
        className="col-xs-4"
      >
        <Link
          to={getPath('frontend', item.itemType, item.itemId)}
          data-tip={`<h2>${item.title}</h2><div class="tooltip-content">${summary}</div>`}
        >
          <div
            className="preview-image"
            alt={item.title}
            style={{ backgroundImage: `url(${url})` }}
          />
        </Link>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/frontend/base/components/ItemPreviewItem.js